// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bw-locationTitle{max-width:75%}.bw-airportCode{margin-left:.1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"locationTitle": "bw-locationTitle",
	"airportCode": "bw-airportCode"
};
module.exports = ___CSS_LOADER_EXPORT___;
